module.exports = __webpack_public_path__ + "img/tarj-qinspecting-site.53101766.png";